import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { WarehouseTableColumns } from "../../domain/columns/warehouseTableColumns";
import { warehouseSchema } from "../../domain/schemas/warehouseSchema";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { WarehouseTableFilters } from "../features/warehouseTableFilters";

export const WarehousePage = () => {
  const { t } = useTranslation("common");

  const dispatch = useAppDispatch();

  const title = t("Warehouses");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootWarehouse",
      fields: {},
    },
    "warehouseFilter",
  );

  const crud = useCrudTable({
    prefix: "warehouses",
    entity: "Warehouse",
    columns: WarehouseTableColumns,
    schema: warehouseSchema,
    addAction: "/warehouses/add",
    columnAction: "/warehouses/edit/:id",
    filters: crudFilters.filters,
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className="mb-3" />
          <WarehouseTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
